export default {
  labels: {
    page: 'Sivu {{current}} / {{total}}',
    no_file_specified: 'Tiedostoa ei määritetty',
  },
  buttons: {
    previous: 'Edellinen',
    next: 'Seuraava',
  },
};
